export const HOST = process.env.REACT_APP_HOST as string
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY as string
export const SUCCESS_PAGE = process.env.REACT_APP_SUCCESS_PAGE as string
export const PRICE_CATEGORY=process.env.REACT_APP_PRICES_CATEGORY
export const PAYMENT_PROVIDER = process.env.REACT_APP_PAYMENT_PROVIDER as 'stripe' | 'paddle'
export const PADDLE_VENDOR_ID = process.env.REACT_APP_PADDLE_VENDOR_ID as string
export const PADDLE_ENVIRONMENT = process.env.REACT_APP_PADDLE_ENVIRONMENT as 'sandbox' | 'production'
export const PADDLE_PRODUCT_ID = process.env.REACT_APP_PADDLE_PRODUCT_ID as string
export const CREATING_PROGRAM_VERSION = (process.env.REACT_APP_CREATING_PROGRAM_VERSION || 'v1') as 'v1' | 'v2'
export const PAYWALL_VERSION = (process.env.REACT_APP_PAYWALL_VERSION || "1") as "1" | "2" | "random"
export const BI_SERVICE_HOST = "https://getbackdeposit.com:8003"

export enum SubscriptionEvent {
    Initiated = 'subscription_initiated',
    Failed = 'subscription_failed',
    Successful = 'subscription_successful',
}